import {CdFrequencyInterval} from '../../../interfaces/care/cd-care-plan/cd-frequency-interval';
import {CdFrequencyType} from '../../../interfaces/care/cd-care-plan/cd-frequency-type';
import {CdFrequencyTypeFactory} from './cd-frequency-type-factory';

export class CdFrequencyIntervalFactory {
  public static fromObject(cdFrequencyInterval: any): CdFrequencyInterval {
    return new class implements CdFrequencyInterval {
      cdFrequencyId: number = cdFrequencyInterval.cd_frequency_id;
      created: string = cdFrequencyInterval.created;
      id: number = cdFrequencyInterval.id;
      modified: string = cdFrequencyInterval.modified;
      userId: number = cdFrequencyInterval.user_id;
      weekday: number = cdFrequencyInterval.weekday;
      cdFrequencyTypeId: number = cdFrequencyInterval.c_frequency_type_id;
      cdFrequencyType: CdFrequencyType =
        cdFrequencyInterval.c_frequency_type ? CdFrequencyTypeFactory.fromObject(cdFrequencyInterval.c_frequency_type) : null;
    };
  }

  public static fromArray(cdFrequencyIntervals: any[]): CdFrequencyInterval[] {
    return cdFrequencyIntervals.map(_cdFrequencyInterval => CdFrequencyIntervalFactory.fromObject(_cdFrequencyInterval));
  }

  /**
   * Maps a CdFrequencyInterval to its remote payload. Only the
   * fields we actually create locally are sent - userId and the
   * embedded cdFrequencyType are intentionally omitted.
   *
   * IMPORTANT: Frequency intervals are only sent in the context
   * of a CdTemporaryMeasure - see CdFrequencyFactory.toRemote.
   *
   * @param cdFrequencyInterval
   */
  public static toRemote(cdFrequencyInterval: CdFrequencyInterval): any {
    return {
      id: cdFrequencyInterval.id,
      cd_frequency_id: cdFrequencyInterval.cdFrequencyId,
      c_frequency_type_id: cdFrequencyInterval.cdFrequencyTypeId,
      weekday: cdFrequencyInterval.weekday
    };
  }

  /**
   *
   * @param cdFrequencyIntervals
   */
  public static toArray(cdFrequencyIntervals: CdFrequencyInterval[]): any[] {
    return cdFrequencyIntervals.map(_cdFrequencyInterval =>
      CdFrequencyIntervalFactory.toRemote(_cdFrequencyInterval)
    );
  }

  /**
   *
   * @param weekday
   * @param cdFrequencyTypeId
   */
  public static new(weekday: number = null, cdFrequencyTypeId: number = null): CdFrequencyInterval {
    return new class implements CdFrequencyInterval {
      id: number = null;
      cdFrequencyId: number = null;
      weekday: number = weekday;
      userId: number = null;
      created: string = new Date().toISOString();
      modified: string = new Date().toISOString();
      cdFrequencyTypeId: number = cdFrequencyTypeId;
      cdFrequencyType: CdFrequencyType = null;
    };
  }

}
